import { SvgIcon, useTheme } from '@mui/material';

export function LockIcon({ color }: { color?: string }) {
  const theme = useTheme();
  return (
    <SvgIcon viewBox="0 0 24 24" fontSize="small">
      <path
        d="M10 0C7.23858 0 5 2.23858 5 5V7.5H4.16667C3.24619 7.5 2.5 8.24619 2.5 9.16667V16.6667C2.5 17.5871 3.24619 18.3333 4.16667 18.3333H15.8333C16.7538 18.3333 17.5 17.5871 17.5 16.6667V9.16667C17.5 8.24619 16.7538 7.5 15.8333 7.5H6.66667V5C6.66667 3.15905 8.15905 1.66667 10 1.66667C11.3711 1.66667 12.5506 2.49458 13.0625 3.68111C13.2448 4.10371 13.7351 4.2985 14.1577 4.1162C14.5803 3.9339 14.7751 3.44354 14.5928 3.02095C13.8269 1.24542 12.0598 0 10 0Z"
        fill={color || theme.palette.colors.content['danger-secondary']}
      />
    </SvgIcon>
  );
}
